import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import VATAccrualReport from './VATAccrualReport';
import BASAccrualReport from './BASAccrualReport';

/**
 * Tax Returns — one sidebar entry, one page, a tab per jurisdiction
 * (Vishal 2026-07-03: "make VAT and GST as tabs instead of multiple sidebar
 * menu items"). Old deep links /finance/vat-return (tab 0) and /finance/bas-return
 * (tab 1) stay routed here with the matching initial tab.
 *
 * Both jurisdictions file on the ACCRUAL basis — input VAT/GST claimed when the cost
 * is INCURRED, from the SCM-owned, editable supplier_invoices table at invoice date
 * (never quickbooks.* directly), plus ad spend at the month incurred. Accrual is what
 * EF actually files on.
 *
 * The cash-basis tabs (UK VAT cash / AU GST BAS) were removed 2026-09-07 (Vishal:
 * "it's the accrual which is what is used to file"). Their report components
 * VATReturnReport / BASReturnReport still exist but are no longer rendered anywhere.
 */
export default function TaxReturns({ initialTab = 0 }) {
  const [tab, setTab] = useState(initialTab);
  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, pt: 1 }}>
        <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
          <Tab label="UK VAT" />
          <Tab label="AU GST" />
        </Tabs>
      </Box>
      {tab === 0 && <VATAccrualReport />}
      {tab === 1 && <BASAccrualReport />}
    </Box>
  );
}
